<script lang="ts">
	import TableCell from 'components/Table/TableCell/TableCell.svelte';
	import TableRow from 'components/Table/TableRow/TableRow.svelte';
	import NoIcon from 'assets/svg/noCoinIcon.svg?url';
	import { onErrorCoinLogo } from 'utils/onErrorCoinLogo';
	import formatNumber from 'utils/formatNumber';
	import activeCurrency from 'stores/activeCurrency';
	import getClientWidth from 'utils/getClientWidth';
	import { browser } from '$app/environment';
	import { onMount } from 'svelte';
	import WalletIcon from 'assets/svg/wallet.svg?component';
	import processWalletAdrress from 'utils/processWalletAdrress';
	import type { IExchangeReserves } from 'customTypes/exchange';

	export let dark = false;
	export let data: IExchangeReserves;
	let isMobileView: boolean;

	const { currency, platform, balance, wallet_address } = data;

	$: calcualatedBalance = formatNumber(
		balance * $activeCurrency.price,
		$activeCurrency.currency,
		isMobileView,
		'currency',
	);
	$: calculatedPrice = formatNumber(
		currency.price_usd * $activeCurrency.price,
		$activeCurrency.currency,
		isMobileView,
		'decimal',
	);
	$: calculatedValue = formatNumber(
		balance * currency.price_usd * $activeCurrency.price,
		$activeCurrency.currency,
		isMobileView,
		'currency',
	);

	onMount(() => {
		if (!browser) return;
		calculateViewportWidth();
		window.addEventListener('resize', calculateViewportWidth);
		return () => {
			window.removeEventListener('resize', calculateViewportWidth);
		};
	});

	function calculateViewportWidth() {
		const viewportWidth = getClientWidth();
		isMobileView = viewportWidth < 768;
	}
</script>

<TableRow {dark} class="reserves-table-row">
	<TableCell {dark} class="reserves-name">
		<div class="logos-wrapper">
			<img
				class="token-icon"
				src={currency.logo_url ?? NoIcon}
				alt={`${currency.name} logo`}
				loading="lazy"
				on:error={onErrorCoinLogo}
			/>
			<img
				class="blockchain-icon"
				class:dark
				src={platform.logo_url ?? NoIcon}
				alt={`${platform.name} logo`}
				loading="lazy"
				on:error={onErrorCoinLogo}
			/>
		</div>

		<div class="blockchain-data" class:dark>
			<p class="name">{currency.symbol}</p>
			<div class="wallet-wrapper">
				<WalletIcon width={12} height={12} class="wallet-icon" />
				<p class="wallet-address" class:dark>{processWalletAdrress(wallet_address, 5)}</p>
			</div>
		</div>
	</TableCell>
	<TableCell {dark} class="reserves-balance">
		{calcualatedBalance}
	</TableCell>
	<TableCell {dark} class="reserves-price">
		{calculatedPrice}
	</TableCell>
	<TableCell {dark} class="reserves-value">
		{calculatedValue}
	</TableCell>
</TableRow>

<style lang="scss">
	@import 'financialReservesTableRow';
</style>
